/**
 * Called by the event dispatcher to render the image.
 */
export default function getTinyBrushMixin(context, widthOfRect, heightOfRect, xCoords, yCoords, color) {
  context.rect(
    xCoords - widthOfRect / 2,
    yCoords - heightOfRect / 2,
    widthOfRect,
    heightOfRect
  );
  context.stroke();
  context.beginPath();

  const widthOfSecondSquare = widthOfRect * 0.2 < 3 ? widthOfRect * 0.2 : 3;
  const heightOfSecondSquare = heightOfRect * 0.2 < 3 ? heightOfRect * 0.2 : 3;

  context.lineWidth = widthOfSecondSquare;
  context.strokeStyle = `rgba(${color.join()}, 1)`;
  context.rect(
    xCoords + widthOfSecondSquare / 2 - widthOfRect / 2,
    yCoords + heightOfSecondSquare / 2 - heightOfRect / 2,
    widthOfRect - widthOfSecondSquare,
    heightOfRect - heightOfSecondSquare
  );
  context.stroke();

  context.beginPath();

  context.rect(
    xCoords + widthOfSecondSquare - widthOfRect / 2,
    yCoords + heightOfSecondSquare - heightOfRect / 2,
    widthOfRect - widthOfSecondSquare * 2,
    heightOfRect - heightOfSecondSquare * 2
  );
  context.fillStyle = `rgba(${color.join()}, 0.25)`;
}